import { User } from './user';

export type File = {
    _id: string;
    filename: string;
    mimetype: string;
    url: string;
    created: {
        on: number;
        by?: User;
    };
};

// Mirrors `FileSource` in shared-denthub-code (src/models/file-source.ts).
// denthub-documents rejects `POST /upload/files` whose `source` is not one of
// these values, so never hand-type a source string — use the enum.
export enum FileSource {
    ORDER_ATTACHMENTS = 'ORDER_ATTACHMENTS',
    ORDER_INTERNAL_ATTACHMENTS = 'ORDER_INTERNAL_ATTACHMENTS',
    ORDER_INTERNAL_CONSTRUCTION_ATTACHMENTS = 'ORDER_INTERNAL_CONSTRUCTION_ATTACHMENTS',
    ORDER_INTERNAL_MILLING_JOB = 'ORDER_INTERNAL_MILLING_JOB',
    MILLING_BATCH = 'MILLING_BATCH',
    SCANNER_CASES = 'SCANNER_CASES',
    SETTINGS = 'SETTINGS',
    ORDER_FORM = 'ORDER_FORM',
    WAYBILL = 'WAYBILL',
    INVOICE_PDF = 'INVOICE_PDF',
    INVOICE_SPECIFICATION_PDF = 'INVOICE_SPECIFICATION_PDF',
    DELIVERY_NOTE_PDF = 'DELIVERY_NOTE_PDF',
    PEPPOL_ARCHIVE = 'PEPPOL_ARCHIVE',
}
